import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ReleaseFieldType } from 'services/store/distribution/types';

const useValidationSchema = () => {
  const { t } = useTranslation();

  const songTitle = yup
    .string()
    .trim()
    .required(
      t('messages:validation.required', {
        field: t(
          `distribution:tracklist:fields:${ReleaseFieldType.SongTitle}:name`
        ),
      })
    );

  return songTitle;
};

export default useValidationSchema;
